"use strict";

var AbstractDecoder = require("../abstractdecoder.js");

function RawDecoder() {}

RawDecoder.prototype = Object.create(AbstractDecoder.prototype);
RawDecoder.prototype.constructor = RawDecoder;
RawDecoder.prototype.decodeBlock = function (buffer) {
  return buffer;
};

module.exports = RawDecoder;


//////////////////
// WEBPACK FOOTER
// ./node_modules/geotiff/dist/compression/raw.js
// module id = 54
// module chunks = 0